import { useState } from 'react';

/**
 * Footer bottom attribution bar with custom logos for InfinityBusiness and MarkedHost.
 * Black background (#050508) to match deep-black theme.
 */
export default function FooterAttributionBar() {
  const [year] = useState(new Date().getFullYear());

  function openBugReport(e) {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('emina:open-bug-report'));
  }

  return (
    <div className="bg-black border-t border-white/5 text-slate-400" data-testid="footer-attribution">
      <div className="max-w-7xl mx-auto px-4 py-3 text-[11px] leading-relaxed">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2.5 md:gap-4">
          <p className="text-slate-400 text-center md:text-left" data-testid="attribution-copyright">
            © {year} Liber Nostra d.o.o. Sva prava pridržana.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-slate-400">
            <span className="hidden md:inline text-slate-700">|</span>
            <span>Razvijeno i održavano od</span>
            <a href="https://infinitybusiness.org" target="_blank" rel="noopener noreferrer"
               className="inline-flex items-center gap-1.5 text-red-400 hover:text-red-300"
               data-testid="attribution-ib-link">
              <img src="/attribution/ib-logo.png" alt="InfinityBusiness" className="h-5 w-5 object-contain" />
              <span className="underline">infinitybusiness.org</span>
            </a>
            <span className="text-slate-700">|</span>
            <span>Hostirano od</span>
            <a href="https://markedhost.com" target="_blank" rel="noopener noreferrer"
               className="inline-flex items-center gap-1.5 text-red-400 hover:text-red-300"
               data-testid="attribution-mh-link">
              <img src="/attribution/markedhost-logo.png" alt="MarkedHost" className="h-5 md:h-6 object-contain" />
            </a>
          </div>
          <p className="text-slate-400 text-center md:text-right">
            Neki sadržaji stvoreni uz pomoć AI —{' '}
            <a href="#bug-report" onClick={openBugReport}
               className="text-red-400 hover:text-red-300 underline" data-testid="attribution-bug-link">
              prijavite probleme ovdje
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
